<template>
  <div>
    <Loading :loading="this.loading"></Loading>
  </div>
</template>

<script>
import Loading from '@/views/v3/Loading.vue'
import { usePreferredDateStore } from '@/store/preferredDate'

export default {
  data () {
    return {
      loading: true
    }
  },
  computed: {
    preferredDateStore: function () {
      return usePreferredDateStore()
    }
  },
  async mounted () {
    const preferredDateStore = usePreferredDateStore()
    preferredDateStore.preferredDate = {
      price: this.preferredDateStore.preferredDate.price,
      car: this.preferredDateStore.preferredDate.car,
      expiryOnWareki: this.preferredDateStore.preferredDate.expiryOnWareki,
      firstRegistrationOnWareki: this.preferredDateStore.preferredDate.firstRegistrationOnWareki,
      Manufacturer: this.preferredDateStore.preferredDate.Manufacturer,
      carType: this.preferredDateStore.preferredDate.carType,
      nativeData: this.preferredDateStore.preferredDate.nativeData,
      tsId: this.preferredDateStore.preferredDate.tsId,
      ssInfo: this.preferredDateStore.preferredDate.ssInfo,
      inspectSsInfo: this.preferredDateStore.preferredDate.inspectSsInfo,
      profileInfo: this.preferredDateStore.preferredDate.profileInfo,
      versionData: this.preferredDateStore.preferredDate.versionData,
      pitlockshopDetails: this.preferredDateStore.preferredDate.pitlockshopDetails,
      post: this.preferredDateStore.preferredDate.post
    }
    this.$router.push({
      name: 'PreferredDateV3'
    })
  },
  components: {
    Loading
  }
}

</script>
